import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getTestimonialSliceContent = createAsyncThunk('/testimonials/content', async () => {
    var userData=JSON.parse(localStorage.getItem("userData"));
	const response = await axios.post(`${API_URL}/getStudentTestimonial`, {});
	return response;
})

export const testimonialSlice = createSlice({
    name: 'testimonials',
    initialState: {
        isLoading: false,
        testimonials : []
    },
    reducers: {
    },
    extraReducers: {
		[getTestimonialSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getTestimonialSliceContent.fulfilled]: (state, action) => {
			state.testimonials = action.payload.data
			state.isLoading = false
		},
		[getTestimonialSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default testimonialSlice.reducer